import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { ScoreGroupNodeView } from "@/components/unified/ScoreGroupNodeView";

export const ScoreGroupNodeExtension = Node.create({
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.dataset.scoregroupId,
        renderHTML: (attributes) => ({ "data-scoregroup-id": attributes.id as string | null }),
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ScoreGroupNodeView, {
      stopEvent: ({ event }) => {
        const target = event.target as HTMLElement;
        return target.closest('input, button, [role="button"]') !== null;
      },
    });
  },

  atom: true,

  group: "block",

  name: "scoregroupNode",

  parseHTML() {
    return [{ tag: "div[data-scoregroup-id]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", HTMLAttributes];
  },
});
